export default "__VITE_ASSET__DrMSndL6__"